export default __webpack_public_path__ + "static/media/srisailamVisitNine.01e6e11d.jpg";